<div class="dialog-content">
  <h1 mat-dialog-title>
    {{ 'containerComponents.hubSelection.dialog.selectHub' | translate }}
  </h1>
  <div mat-dialog-content>
    <div [hidden]="noHubsExist()">
      <ui-list-filter
        [filtersConfig]="filterConfig"
        (filtersChange)="fetchListBySearchCriteria($event)"
      ></ui-list-filter>
      <mat-table [dataSource]="dataSource" noDataTableMessage>
        <ng-container matColumnDef="select">
          <mat-header-cell *matHeaderCellDef>
            <mat-checkbox
              (change)="$event ? masterToggle($event.checked) : null"
              [checked]="(hasValue$ | async) && isAllSelected()"
              [indeterminate]="(hasValue$ | async) && !isAllSelected()"
            >
            </mat-checkbox>
          </mat-header-cell>
          <mat-cell *matCellDef="let row">
            <mat-checkbox
              (click)="$event.stopPropagation()"
              (change)="$event ? toggle(row, $event.checked) : null"
              [checked]="selectedRows.has(row.id)"
            >
            </mat-checkbox>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="name">
          <mat-header-cell *matHeaderCellDef>
            {{ 'common.list.th.name' | translate }}
          </mat-header-cell>
          <mat-cell *matCellDef="let element">
            {{ element.name }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="ssccId">
          <mat-header-cell *matHeaderCellDef>
            {{ 'administration.hub.field.ssccId' | translate }}
          </mat-header-cell>
          <mat-cell *matCellDef="let element">
            {{ element.ssccId }}
          </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row
          *matRowDef="let row; columns: displayedColumns"
          [class.selected]="selectedRows.has(row.id)"
          (click)="toggle(row, !selectedRows.has(row.id))"
        ></mat-row>
      </mat-table>

      <mat-paginator #paginator> </mat-paginator>
    </div>

    <div *ngIf="noHubsExist() && (hubListFacade.loaded$ | async) && !(loadingFacade.loading$ | async)">
      {{ 'administration.hub.list.noItems' | translate }}
    </div>
  </div>
  <div mat-dialog-actions class="tw-flex tw-justify-between">
    <ui-action-button [action]="buttonAction.Cancel" (buttonClick)="closeDialog()"></ui-action-button>
    <ui-action-button
      *ngIf="!noHubsExist() && !(loadingFacade.loading$ | async); else createHubTemplate"
      [action]="buttonAction.Save"
      [type]="buttonType.Primary"
      [disabled]="isFormUnchanged(initialHubList, updatedHubList())"
      (buttonClick)="confirm()"
    ></ui-action-button>
  </div>
</div>

<ng-template #createHubTemplate>
  <button
    mat-raised-button
    routerLink="/dashboard/administration/hubs"
    testId="create-button-link"
    (click)="closeDialog()"
  >
    {{ 'common.button.goToHubs' | translate }}
  </button>
</ng-template>
